export default __webpack_public_path__ + "static/media/sass.91714f74.png";